import React, { useEffect } from 'react';

import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import { roleNames, useSessionStore } from '../../../stores';

import PageHeader from '../../../components/common/PageHeader';
import AddPaymentMethodModal from '../../../components/modals/paymentMethod/AddPaymentMethodModal';

function PaymentMethodListHeader() {
  const currentCustomer = useSessionStore.use.currentCustomer();
  const hasRoles = useSessionStore.use.hasRoles();

  const [canAddPaymentMethod, setCanAddPaymentMethod] = React.useState(false);
  const [addMethod, setAddMethod] = React.useState(false);

  useEffect(() => {
    setCanAddPaymentMethod(hasRoles(roleNames.billing, roleNames.paymentMethod));
  }, [currentCustomer]);

  const handleAddPaymentMethodClick = async () => {
    setAddMethod(true);
  };

  const handlePaymentMethodAddOrCancel = () => {
    setAddMethod(false);
  };

  return (
    <>
      <AddPaymentMethodModal isOpen={addMethod} onCancel={handlePaymentMethodAddOrCancel} onSave={handlePaymentMethodAddOrCancel} />
      <PageHeader title="Payment Methods">
        <Button
          disabled={!canAddPaymentMethod}
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAddPaymentMethodClick}
          sx={{ position: 'relative', top: { xs: '-3px', sm: '-5px' } }}
          title="Add Payment Method"
        >
          Add
        </Button>
      </PageHeader>
    </>
  );
}

export default PaymentMethodListHeader;
